import { Component, OnInit } from '@angular/core';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { AlwaysTrue, RuleInterface } from '@vendasta/automata';
import { TranslateModule } from '@ngx-translate/core';
import { TriggerBaseRules } from '../../../common/decorators/trigger-rules.decorator';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-ask-question-panel',
  templateUrl: './ask-question-panel.component.html',
  styleUrls: [],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class AskQuestionPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  ngOnInit(): void {
    super.ngOnInit();
    // Nothing to async load so we can enable saving.
    this.savingEnabled$.next(true);
  }

  @TriggerBaseRules
  getBaseRules(): RuleInterface[] {
    return [new AlwaysTrue('').toRuleInterface()];
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  isFormValid(): boolean {
    return true;
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    return rules;
  }
}
